import React from 'react';
import { motion } from 'framer-motion';
import type { DeliverableStatus } from '../types/portal';
import { clientStatusLabel, isReviewable } from '../utils/deliverables';
interface StatusTagProps {
  status: DeliverableStatus;
  /** Client wording, Portal's internal wording, or the review-page wording. */
  audience?: 'client' | 'portal' | 'review';
}
function labelFor(status: DeliverableStatus, audience: 'client' | 'portal' | 'review'): string {
  if (audience === 'portal') return status.toUpperCase();
  return clientStatusLabel(status);
}
export function StatusTag({
  status,
  audience = 'client'
}: StatusTagProps) {
  const attention = isReviewable(status);
  const settled = status === 'Approved' || status === 'Delivered';
  return <span className={['label inline-flex items-center whitespace-nowrap border px-2.5 py-1.5', attention ? 'border-ink bg-ink text-paper' : settled ? 'border-graphite/40 text-graphite' : 'border-rule text-mute'].join(' ')} data-id="element-421" data-mp="2millf5ykz66j">
      {/* Every status change gets a brief, specific motion instead of an
          instant text swap — the moments this tag changes are usually the
          moments that matter most: approved, ready for review. Keyed on the
          status itself, so React remounts and replays the motion each time
          it actually changes, not on every re-render. */}
      <motion.span key={status} initial={{
      opacity: 0,
      y: 3
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.18,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-422" data-mp="l0tya7orsoph">
        {labelFor(status, audience)}
      </motion.span>
    </span>;
}